import { forwardRef } from 'react';
import { CellulaInputRadioItem, InputRadioItemProps } from './_input_radio_item.component';
import { CellulaInputRadioRoot, InputRadioRootProps } from './_input_radio_root.component';

export const InputRadio = {
	Root: forwardRef(CellulaInputRadioRoot),
	Item: forwardRef(CellulaInputRadioItem),
} as const;
export type { InputRadioItemProps, InputRadioRootProps };
